/**
 * @description
 */

import Api from '../../path';
import { ECollectionType } from '@umu/umu-types';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    obj_type: ECollectionType;
    obj_id: number;
}

export interface IOutput {
    /** 0 操作失败；1 操作成功 */
    status: number;
}

export const cancelCollection = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.CANCEL_COLLECTION, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
